export enum PakLocationViewMode {
  List = 'list',
  ThreeD = '3d',
}
